/* NILO V5.13.66 — Editorial Share Studio FR / AR. Scoped to Share Look only. */
(function () {
  'use strict';
  if (window.__niloShareStudio51332) return;
  window.__niloShareStudio51332 = true;
  var states = new WeakMap();
  function qs(root, selector) { return (root || document).querySelector(selector); }
  function make(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function isArabic() { return /^ar(?:-|$)/i.test(document.documentElement.lang || '') || document.documentElement.dir === 'rtl'; }
  function setStatus(root, value) {
    var el = qs(root, '[data-nilo-share-status]'); if (!el) return;
    el.textContent = value || '';
    if (value) setTimeout(function () { if (el.textContent === value) el.textContent = ''; }, 6000);
  }
  function rounding(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2); ctx.beginPath(); ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }
  function rect(ctx, x, y, w, h, r, color) { ctx.fillStyle = color; rounding(ctx, x, y, w, h, r); ctx.fill(); }
  function fontFor(ar) { return ar ? '"Noto Sans Arabic", Tahoma, Arial, sans-serif' : 'Arial, Helvetica, sans-serif'; }
  function fitText(ctx, text, maxWidth, fontSize, weight, minFont, ar) {
    var size = fontSize;
    while (size > (minFont || 18)) {
      ctx.font = weight + ' ' + size + 'px ' + fontFor(ar);
      if (ctx.measureText(text).width <= maxWidth) break;
      size -= 2;
    }
    ctx.font = weight + ' ' + size + 'px ' + fontFor(ar);
    return size;
  }
  function ellipsis(ctx, str, maxWidth) {
    if (ctx.measureText(str).width <= maxWidth) return str;
    while (str.length > 1 && ctx.measureText(str + '…').width > maxWidth) str = str.slice(0, -1);
    return str.trim() + '…';
  }
  function linesFor(ctx, text, maxWidth, maxLines) {
    var words = String(text || '').trim().split(/\s+/), lines = [], line = '';
    for (var i = 0; i < words.length; i++) {
      var candidate = line ? line + ' ' + words[i] : words[i];
      if (line && ctx.measureText(candidate).width > maxWidth) { lines.push(line); line = words[i]; }
      else line = candidate;
      if (lines.length === maxLines) { lines[maxLines - 1] = ellipsis(ctx, lines[maxLines - 1] + ' ' + words.slice(i).join(' '), maxWidth); return lines; }
    }
    if (line) lines.push(ellipsis(ctx, line, maxWidth));
    return lines;
  }
  function t(key, ar) {
    var fr = {
      intro: 'Le look du moment', delivery: 'Paiement à la livraison',
      cta: 'Commander maintenant', promise: 'Ouvre ton colis avant de payer',
      social: 'TON LOOK. TON PRIX.', available: 'Disponible sur nilo.ma',
      product: 'Look Nilo', price: 'Voir le prix', off: 'OFFRE NILO',
      panel: 'Envoie ce look ✦', panelDesc: 'Choisis un format, télécharge et partage le lien produit.',
      format: 'Format du visuel', story: 'Story / Reel · 9:16', square: 'Post Instagram · 4:5',
      download: 'Télécharger ', copy: 'Copier le lien produit', productLink: 'Commander maintenant sur nilo.ma  ↗',
      note: 'Dans l’image, le bouton est visuel. Partage le lien pour qu’il soit cliquable (ou ajoute le sticker Lien en Story).',
      ready: 'PRÊT', loading: 'Création du visuel…', error: 'Image indisponible',
      sent: 'Partage terminé ✓', copied: 'Lien produit copié ✓', impossible: 'Image indisponible, réessaie.',
      downloaded: 'Image téléchargée ✓', fallback: 'Télécharge le visuel puis partage son lien.',
      platform: 'Partager avec le lien produit', share: 'Partager ce look avec une amie', shareSub: 'Visuel Nilo prêt à envoyer',
      label: 'NILO · PARTAGE', status: 'Image prête à partager'
    };
    var ara = {
      intro: 'لوك اليوم', delivery: 'الدفع عند الاستلام',
      cta: 'طلبي دابا', promise: 'حلي الكولي وتأكدي قبل ما تخلصي',
      social: 'لبسة زوينة بثمن كيعجب', available: 'تلقايه فـ nilo.ma',
      product: 'لوك نيلو', price: 'شوفي الثمن', off: 'عرض نيلو',
      panel: 'شاركي هاد اللوك ✦', panelDesc: 'اختاري القياس، حمّلي التصويرة وشاركي رابط المنتوج.',
      format: 'قياس التصويرة', story: 'ستوري / ريلز · 9:16', square: 'منشور إنستغرام · 4:5',
      download: 'حمّلي ', copy: 'نسخي رابط المنتوج', productLink: 'طلبي دابا من nilo.ma  ↗',
      note: 'الزر فالتصويرة غير للعرض. إلى بغيتيه يكون قابل للكليك، شاركي الرابط أو زيدي ستيكر الرابط فالستوري.',
      ready: 'واجد', loading: 'كنوجدّو التصويرة…', error: 'التصويرة ما تحملاتش',
      sent: 'تشاركات ✓', copied: 'تنسخ رابط المنتوج ✓', impossible: 'التصويرة ما وجداتش، عاودي.',
      downloaded: 'تحملات التصويرة ✓', fallback: 'حمّلي التصويرة وشاركي الرابط.',
      platform: 'شاركي المنتوج والرابط', share: 'شاركي هاد اللوك مع صحبتك', shareSub: 'التصويرة واجدة للإرسال',
      label: 'نيلو · مشاركة', status: 'التصويرة واجدة للمشاركة'
    };
    return (ar ? ara : fr)[key] || '';
  }
  function arTitleFromProduct(root) {
    var page = root.closest('[data-nilo-product-page]') || document;
    var headline = qs(page, '.nilo-product-title-row h1');
    var localized = (headline && headline.textContent || root.dataset.shareTitle || '').trim();
    if (localized && !/[A-Za-zÀ-ÖØ-öø-ÿ]/.test(localized) && localized.split(/\s+/).length <= 5) return localized;
    var source = (localized + ' ' + (root.dataset.shareTitle || '')).toLowerCase();
    function has(rx) { return rx.test(source); }
    if (has(/ensemble|طقم|اطقم|أطقم/)) return has(/large|واسع|oversize/) ? 'طقم واسع وأنيق' : 'طقم نسائي أنيق';
    if (has(/robe|dress|فستان|فساتين/)) return has(/long|longue|طويل/) ? 'فستان طويل وأنيق' : 'فستان أنيق';
    if (has(/abaya|عباية|عبايات/)) return 'عباية أنيقة';
    if (has(/jellaba|جلابة|جلابات/)) return 'جلابة أنيقة';
    if (has(/cardigan|gilet|كارديغان|جيلي/)) return 'كارديغان أنيق';
    if (has(/manteau|coat|معطف/)) return 'معطف أنيق';
    if (has(/jupe|skirt|تنورة/)) return 'تنورة أنيقة';
    if (has(/pantalon|pants|بنطلون|سروال/)) return 'سروال مريح';
    if (has(/chemise|shirt|قميص/)) return 'قميص أنيق';
    if (has(/hijab|حجاب/)) return 'حجاب أنيق';
    if (has(/chaussure|sneaker|sandale|حذاء|صندل/)) return 'حذاء أنيق';
    if (has(/sac|bag|حقيبة/)) return 'حقيبة أنيقة';
    if (has(/pull|sweater|كنزة|بلوزة|blouse/)) return 'بلوزة أنيقة';
    return 'لوك نيلو';
  }
  function localizedMoney(value, ar) {
    if (!ar) return value;
    return String(value || '').replace(/\b(?:MAD|DH|DHS)\b/gi, 'درهم');
  }
  function drawPhoto(ctx, image, x, y, w, h, r) {
    ctx.save(); rounding(ctx, x, y, w, h, r); ctx.clip();
    ctx.fillStyle = '#eeece4'; ctx.fillRect(x, y, w, h);
    if (image && image.width && image.height) {
      // Blurred cover fills the backdrop, while the actual garment is always fully visible.
      var ir = image.width / image.height, br = w / h;
      var cw = br > ir ? w : h * ir, ch = br > ir ? w / ir : h;
      ctx.save(); ctx.filter = 'blur(24px)'; ctx.globalAlpha = .38;
      ctx.drawImage(image, x + (w - cw) / 2 - 24, y + (h - ch) / 2 - 24, cw + 48, ch + 48);
      ctx.restore();
      var scale = Math.min(w / image.width, h / image.height), iw = image.width * scale, ih = image.height * scale;
      ctx.drawImage(image, x + (w - iw) / 2, y + (h - ih) / 2, iw, ih);
    }
    ctx.restore();
  }
  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      if (!url) { reject(new Error('image missing')); return; }
      var absolute; try { absolute = new URL(url, location.href).href; } catch (e) { absolute = url; }
      function browserImage() {
        var img = new Image(); img.crossOrigin = 'anonymous';
        img.onload = function () { resolve(img); }; img.onerror = function () { reject(new Error('image inaccessible')); };
        img.src = absolute;
      }
      fetch(absolute, { mode: 'cors', credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('image fetch'); return r.blob();
      }).then(function (blob) {
        var blobUrl = URL.createObjectURL(blob), img = new Image();
        img.onload = function () { URL.revokeObjectURL(blobUrl); resolve(img); };
        img.onerror = function () { URL.revokeObjectURL(blobUrl); browserImage(); };
        img.src = blobUrl;
      }).catch(browserImage);
    });
  }
  function imageUrl(root) {
    var page = root.closest('[data-nilo-product-page]') || document;
    var index = Math.max(0, (parseInt((qs(page, '[data-nilo-gallery-current]') || {}).textContent || '1', 10) || 1) - 1);
    var all = page.querySelectorAll('.nilo-product-gallery__slide img'); var img = all[index] || all[0];
    return img ? (img.currentSrc || img.src) : (root.dataset.shareImage || '');
  }
  function moneyInfo(root) {
    var page = root.closest('[data-nilo-product-page]') || document;
    var box = qs(page, '[data-nilo-product-price]');
    var actual = box && qs(box, 'strong'), before = box && qs(box, 's');
    var price = actual ? actual.textContent.trim() : '', compare = before && !before.hidden ? before.textContent.trim() : '';
    return { price: price, compare: moneyNumber(compare) > moneyNumber(price) ? compare : '' };
  }
  function moneyNumber(value) {
    var str = String(value || '').replace(/\s/g, '').match(/\d[\d.,]*/); if (!str) return 0;
    var s = str[0].replace(/[^\d.,]/g, ''), comma = s.lastIndexOf(','), point = s.lastIndexOf('.');
    var decimal = Math.max(comma, point);
    if (decimal >= 0 && s.length - decimal - 1 <= 2) s = s.slice(0, decimal).replace(/\D/g, '') + '.' + s.slice(decimal + 1);
    else s = s.replace(/\D/g, '');
    return Number(s) || 0;
  }
  function productUrl(root) {
    // Shopify emits a storefront-localized product URL: retain /ar/ when present.
    var raw = (root.dataset.shareUrl || '').trim(), handle = (root.dataset.shareHandle || '').trim();
    try {
      if (raw) {
        var url = new URL(raw, location.origin);
        if (url.hostname === 'nilo.ma' || url.hostname === 'www.nilo.ma' || url.origin === location.origin) {
          return url.href;
        }
      }
    } catch (e) {}
    if (handle) return 'https://nilo.ma/products/' + encodeURIComponent(handle);
    return 'https://nilo.ma';
  }
  function variantInfo(root) {
    var page = root.closest('[data-nilo-product-page]') || document, sel = qs(page, '[data-nilo-variant-select]');
    if (!sel || !sel.value || !sel.selectedOptions || !sel.selectedOptions[0]) return '';
    var value = sel.selectedOptions[0].textContent.replace(/—.*$/, '').trim();
    return /default title/i.test(value) ? '' : value;
  }

  function socialTitle(root, ar) {
    var raw = (root.dataset.shareTitle || document.title || '').replace(/\s+/g, ' ').trim();
    if (!raw) return ar ? 'لوك نيلو' : 'Look Nilo';
    if (ar) return arTitleFromProduct(root);
    var source = raw.toLowerCase();
    function pick(base, terms) {
      var parts = [base];
      terms.forEach(function (term) { if (source.indexOf(term) !== -1 && parts.indexOf(term) === -1) parts.push(term); });
      return parts;
    }
    var picked = null;
    if (source.indexOf('robe') !== -1) picked = pick('Robe', ['longue', 'maille', 'côtelée', 'fluide', 'imprimé', 'imprimée']);
    if (!picked && source.indexOf('ensemble') !== -1) picked = pick('Ensemble', ['maille', 'tunique', 'capuche', 'large']);
    if (!picked && source.indexOf('abaya') !== -1) picked = pick('Abaya', ['maille', 'premium', 'longue']);
    if (picked) {
      if (picked.length > 1) return picked.join(' ');
      var rawWords = raw.split(/\s+/);
      return rawWords.slice(0, Math.min(4, rawWords.length)).join(' ');
    }
    var words = raw.split(/\s+/).filter(function (w) { return !/^(pour|avec|de|des|du)$/i.test(w); });
    return (words.length < 2 ? raw.split(/\s+/) : words).slice(0, 5).join(' ');
  }

  function shareInfo(root) {
    var m = moneyInfo(root), ar = isArabic();
    var title = socialTitle(root, ar);
    var url = productUrl(root), price = localizedMoney(m.price, ar), compare = localizedMoney(m.compare, ar);
    var text = '✦ ' + t('intro', ar) + '\n' + title + (price ? ' · ' + price : '') +
      (compare ? (ar ? ' (بدل ' + compare + ')' : ' (au lieu de ' + compare + ')') : '') + '\n' +
      '✓ ' + t('delivery', ar) + '\n✓ ' + t('promise', ar) + '\n' +
      '🛍 ' + t('cta', ar) + ' : ' + url + '\n@nilo_app';
    return { ar: ar, title: title, price: price, compare: compare,
      discount: m.compare ? Math.round((1 - moneyNumber(m.price) / moneyNumber(m.compare)) * 100) : 0,
      url: url, text: text, account: root.dataset.shareAccount || '@nilo_app', variant: variantInfo(root) };
  }
  function drawCentered(ctx, text, x, baseline, size, color, weight, ar, maxWidth) {
    ctx.save(); ctx.direction = ar ? 'rtl' : 'ltr'; ctx.textAlign = 'center';
    var n = fitText(ctx, text, maxWidth || 9999, size, weight || '800', 18, ar);
    ctx.fillStyle = color; ctx.fillText(text, x, baseline); ctx.restore(); return n;
  }
  function drawLeft(ctx, text, x, baseline, size, color, weight, ar, maxWidth) {
    ctx.save(); ctx.direction = ar ? 'rtl' : 'ltr'; ctx.textAlign = ar ? 'right' : 'left';
    fitText(ctx, text, maxWidth || 9999, size, weight || '800', 18, ar);
    ctx.fillStyle = color; ctx.fillText(text, x, baseline); ctx.restore();
  }
  function fillGradient(ctx, x0, y0, x1, y1, stops) {
    var grad = ctx.createLinearGradient(x0, y0, x1, y1);
    stops.forEach(function (s) { grad.addColorStop(s[0], s[1]); });
    ctx.fillStyle = grad; ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  }
  function drawHero(ctx, image, story) {
    var W = ctx.canvas.width, H = ctx.canvas.height;
    ctx.fillStyle = '#131416'; ctx.fillRect(0, 0, W, H);
    if (!image || !image.width || !image.height) return;
    // Full-screen product image again, slightly raised, without the old duplicated blurred background.
    var cover = Math.max(W / image.width, H / image.height);
    var cw = image.width * cover, ch = image.height * cover;
    var offsetY = story ? -42 : -26;
    ctx.drawImage(image, (W - cw) / 2, (H - ch) / 2 + offsetY, cw, ch);
    // Single dark overlay for readability, lighter on the upper image area.
    fillGradient(ctx, 0, 0, 0, H, story ? [
      [0, 'rgba(5,6,7,.18)'], [.38, 'rgba(5,6,7,.02)'], [.58, 'rgba(5,6,7,.14)'],
      [.72, 'rgba(5,6,7,.64)'], [.84, 'rgba(5,6,7,.92)'], [1, '#090a0b']
    ] : [[0,'rgba(6,7,8,.12)'], [.34,'rgba(6,7,8,.02)'], [.56,'rgba(6,7,8,.18)'], [.74,'rgba(6,7,8,.70)'], [1,'#090a0b']]);
  }
  function drawBrand(ctx, logoImg, y, ar) {
    rect(ctx, 65, y, 195, 85, 25, '#ffffff');
    if (logoImg && logoImg.width && logoImg.height) {
      var width = 150, height = Math.min(65, width * logoImg.height / logoImg.width);
      ctx.drawImage(logoImg, 88, y + (85 - height) / 2, width, height);
    } else drawLeft(ctx, 'nilo', 89, y + 63, 58, '#090909', '900', false, 140);
    if (ar) {
      ctx.save(); ctx.globalAlpha = .92;
      drawLeft(ctx, '@nilo_app', 294, y + 47, 23, '#ffffff', '800', false, 250);
      ctx.restore();
    } else {
      drawLeft(ctx, '@nilo_app', 294, y + 39, 30, '#ffffff', '900', false, 340);
      drawLeft(ctx, 'LA MODE NILO · MAROC', 296, y + 70, 19, '#ffde46', '800', false, 406);
    }
  }
  function drawPrice(ctx, info, x, y, maxWidth, align) {
    var ar = info.ar; align = align || 'left';
    var main = info.price || t('price', ar);
    fitText(ctx, main, maxWidth - 30, ar ? 66 : 76, '900', 38, ar);
    var mainFont = ctx.font, mainW = ctx.measureText(main).width;
    var comp = info.compare || '', compFont = null, compW = 0;
    if (comp) {
      var remaining = maxWidth - mainW - 18;
      if (remaining > 55) {
        fitText(ctx, comp, remaining, 31, '800', 18, ar);
        compFont = ctx.font; compW = ctx.measureText(comp).width;
      }
    }
    var totalW = mainW + (compFont ? 18 + compW : 0);
    var boxW = totalW + 44, boxH = ar ? 82 : 84;
    var baseX = align === 'right' ? x - totalW : x;
    var boxX = align === 'right' ? x - boxW : x - 20;
    var boxY = y - boxH + 14;
    ctx.save();
    ctx.globalAlpha = .78; rect(ctx, boxX, boxY, boxW, boxH, 24, '#0a0a0c'); ctx.globalAlpha = 1;
    ctx.textAlign = 'left'; ctx.direction = 'ltr';
    ctx.fillStyle = '#ffdd40'; ctx.font = mainFont; ctx.fillText(main, baseX, y);
    if (compFont) {
      var start = baseX + mainW + 18;
      ctx.fillStyle = '#c5c5c5'; ctx.font = compFont; ctx.fillText(comp, start, y - 5);
      ctx.strokeStyle = '#c5c5c5'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(start, y - 18); ctx.lineTo(start + compW, y - 18); ctx.stroke();
    }
    ctx.restore();
    return { x: boxX, y: boxY, w: boxW, h: boxH };
  }
  function drawHeadline(ctx, title, x, y, width, ar, sz, step) {
    ctx.save(); ctx.textAlign = ar ? 'right' : 'left'; ctx.direction = ar ? 'rtl' : 'ltr';
    ctx.fillStyle = '#fff'; fitText(ctx, title, width, sz, '900', 29, ar);
    var lines = linesFor(ctx, title, width, 2);
    if (lines.length > 1 && step * lines.length > 90) {
      fitText(ctx, title, width, sz - 6, '900', 26, ar);
      lines = linesFor(ctx, title, width, 2);
    }
    var base = ar ? x + width : x;
    lines.forEach(function (line, idx) { ctx.fillText(line, base, y + idx * step); });
    ctx.restore(); return lines.length;
  }

  function drawPillText(ctx, text, x, baseline, opts) {
    opts = opts || {};
    var ar = !!opts.ar, align = opts.align || (ar ? 'right' : 'left');
    var size = opts.size || 26, weight = opts.weight || '800';
    var padX = opts.padX || 20, padY = opts.padY || 14, radius = opts.radius || 18;
    var bg = opts.bg || 'rgba(10,10,12,.72)', color = opts.color || '#fff';
    ctx.save(); ctx.direction = ar ? 'rtl' : 'ltr'; ctx.textAlign = align === 'center' ? 'center' : (align === 'right' ? 'right' : 'left');
    fitText(ctx, text, opts.maxWidth || 9999, size, weight, 18, ar);
    var textW = ctx.measureText(text).width, boxW = textW + padX * 2, boxH = size + padY * 2;
    var boxX = align === 'center' ? x - boxW / 2 : (align === 'right' ? x - boxW : x);
    var boxY = baseline - size - padY + 6;
    rect(ctx, boxX, boxY, boxW, boxH, radius, bg);
    ctx.fillStyle = color;
    var tx = align === 'center' ? x : (align === 'right' ? x - padX : x + padX);
    ctx.fillText(text, tx, baseline);
    ctx.restore();
    return { x: boxX, y: boxY, w: boxW, h: boxH };
  }

  function drawCta(ctx, x, y, width, height, ar, fontSize) {
    rect(ctx, x, y, width, height, 23, '#ffdc3e');
    var label = t('cta', ar);
    ctx.save(); ctx.direction = ar ? 'rtl' : 'ltr'; ctx.textAlign = ar ? 'right' : 'left';
    fitText(ctx, label, width - 155, fontSize, '900', 26, ar);
    ctx.fillStyle = '#101010'; ctx.fillText(label, ar ? x + width - 104 : x + 29, y + height * .68);
    ctx.restore();
    var cx = ar ? x + 46 : x + width - 46, cy = y + height / 2;
    ctx.fillStyle = '#101010'; ctx.beginPath(); ctx.arc(cx, cy, 29, 0, 2 * Math.PI); ctx.fill();
    drawCentered(ctx, ar ? '←' : '→', cx, cy + 12, 37, '#ffdc3e', '900', false, 50);
  }
  function canvasFor(root, productImg, logoImg, format) {
    var story = format === 'story', W = 1080, H = story ? 1920 : 1350;
    var canvas = document.createElement('canvas'); canvas.width = W; canvas.height = H;
    var ctx = canvas.getContext('2d'), info = shareInfo(root), ar = info.ar;
    drawHero(ctx, productImg, story);
    if (story) {
      drawBrand(ctx, logoImg, 132, ar);
      rect(ctx, 65, 260, ar ? 214 : 242, 52, 14, '#ffde46');
      drawCentered(ctx, t('intro', ar), 65 + (ar ? 107 : 121), 296, 24, '#0b0b0b', '900', ar, ar ? 187 : 216);
      if (info.discount > 0) {
        rect(ctx, 752, 260, 128, 52, 14, '#e21c42');
        drawCentered(ctx, '-' + info.discount + '%', 816, 297, 29, '#fff', '900', false, 110);
      }
      ctx.fillStyle = '#ffde46'; ctx.fillRect(ar ? 801 : 66, 978, 63, 7);
      drawLeft(ctx, t('social', ar), ar ? 865 : 66, 1032, ar ? 22 : 25, '#f1f1f1', '900', ar, ar ? 620 : 796);
      var priceBox = drawPrice(ctx, info, ar ? 865 : 68, 1124, 798, ar ? 'right' : 'left');
      var lines = drawHeadline(ctx, info.title, ar ? 67 : 68, 1206, 794, ar, ar ? 44 : 43, ar ? 50 : 48);
      var dy = lines === 1 ? 1268 : 1316;
      drawPillText(ctx, t('delivery', ar), ar ? 866 : 68, dy, { ar: ar, align: ar ? 'right' : 'left', size: ar ? 22 : 24, padX: 18, padY: 12, radius: 16, bg: 'rgba(18,18,20,.60)', color: '#fff7d4', maxWidth: 480 });
      drawCta(ctx, 64, 1352, 810, 92, ar, ar ? 47 : 43);
      drawPillText(ctx, '✓ ' + t('promise', ar), ar ? 866 : 68, 1490, { ar: ar, align: ar ? 'right' : 'left', size: ar ? 27 : 27, padX: 20, padY: 13, radius: 18, bg: 'rgba(18,18,20,.76)', color: '#ffffff', maxWidth: 760 });
      ctx.save(); ctx.globalAlpha = .28; ctx.fillStyle = '#ffde46';
      ctx.fillRect(65, 1528, 810, 2); ctx.restore();
      drawLeft(ctx, 'nilo.ma', ar ? 285 : 67, 1566, 52, '#ffde46', '900', ar, 380);
      drawLeft(ctx, ar ? 'موضة بثمن قليل' : 'Lmoda b taman 9lil', ar ? 620 : 69, 1602, ar ? 23 : 23, '#b4b4b4', '800', ar, 620);
    } else {
      drawBrand(ctx, logoImg, 94, ar);
      rect(ctx, 66, 214, ar ? 214 : 244, 50, 14, '#ffde46');
      drawCentered(ctx, t('intro', ar), 66 + (ar ? 107 : 122), 249, 24, '#101010', '900', ar, 220);
      if (info.discount > 0) {
        rect(ctx, 786, 214, 165, 54, 15, '#e21c42');
        drawCentered(ctx, '-' + info.discount + '%', 869, 251, 33, '#fff', '900', false, 140);
      }
      ctx.fillStyle = '#ffde46'; ctx.fillRect(ar ? 799 : 69, 880, 65, 6);
      drawPrice(ctx, info, ar ? 864 : 67, 970, 796, ar ? 'right' : 'left');
      var numLines = drawHeadline(ctx, info.title, ar ? 70 : 69, 1044, 794, ar, ar ? 42 : 42, ar ? 46 : 46);
      drawPillText(ctx, t('delivery', ar), ar ? 864 : 71, numLines > 1 ? 1150 : 1110, { ar: ar, align: ar ? 'right' : 'left', size: ar ? 22 : 24, padX: 18, padY: 12, radius: 16, bg: 'rgba(18,18,20,.60)', color: '#fff7d4', maxWidth: 450 });
      drawCta(ctx, 66, 1174, 810, 88, ar, ar ? 48 : 41);
      drawPillText(ctx, '✓ ' + t('promise', ar), ar ? 865 : 70, 1304, { ar: ar, align: ar ? 'right' : 'left', size: ar ? 28 : 27, padX: 20, padY: 13, radius: 18, bg: 'rgba(18,18,20,.76)', color: '#ffffff', maxWidth: 760 });
    }
    return canvas;
  }
  function formatName(format) { return t(format === 'square' ? 'square' : 'story', isArabic()); }
  function stateFor(root) {
    var state = states.get(root);
    if (!state) { state = { format: 'story', token: 0, canvases: {} }; states.set(root, state); }
    return state;
  }
  function updatePreview(root) {
    var state = stateFor(root), preview = qs(root, '[data-nilo-share-preview-image]');
    var loading = qs(root, '[data-nilo-share-preview-loading]'), ready = qs(root, '[data-nilo-share-ready]');
    root.dataset.niloShareSelectedFormat = state.format;
    root.querySelectorAll('[data-nilo-share-format]').forEach(function (b) {
      var selected = b.dataset.niloShareFormat === state.format; b.setAttribute('aria-pressed', String(selected)); b.classList.toggle('is-active', selected);
    });
    var download = qs(root, '[data-nilo-share-download]');
    if (download) { download.textContent = '↓ ' + t('download', isArabic()) + formatName(state.format); download.disabled = !state.canvases[state.format]; }
    var can = state.canvases[state.format];
    if (can && preview) {
      try { preview.src = can.toDataURL('image/jpeg', .86); preview.hidden = false; if (loading) loading.hidden = true;
        if (ready) { ready.textContent = (state.format === 'square' ? '4:5' : '9:16') + ' · ' + t('ready', isArabic()); ready.classList.add('is-ready'); }
      } catch (e) { if (ready) ready.textContent = t('error', isArabic()); }
    } else {
      if (preview) preview.hidden = true;
      if (loading) { loading.hidden = false; loading.textContent = t(state.error ? 'error' : 'loading', isArabic()); }
      if (ready) { ready.textContent = t(state.error ? 'error' : 'loading', isArabic()); ready.classList.remove('is-ready'); }
    }
  }
  function prepare(root) {
    var state = stateFor(root); state.token++; var token = state.token;
    state.canvases = {}; state.error = false; updatePreview(root);
    var photo = imageUrl(root), logo = root.dataset.shareLogo || '';
    Promise.all([loadImage(photo), loadImage(logo).catch(function () { return null; })]).then(function (imgs) {
      var current = stateFor(root); if (current.token !== token) return;
      try {
        current.canvases = { story: canvasFor(root, imgs[0], imgs[1], 'story'), square: canvasFor(root, imgs[0], imgs[1], 'square') };
        current.imageUrl = photo; updatePreview(root);
      } catch (e) { current.error = true; updatePreview(root); setStatus(root, t('impossible', isArabic())); }
    }).catch(function () { var current = stateFor(root); if (current.token !== token) return;
      current.error = true; updatePreview(root); setStatus(root, t('error', isArabic()));
    });
  }
  function localizePanel(root) {
    var ar = isArabic(), sheet = qs(root, '[data-nilo-share-sheet]'); if (!sheet) return;
    sheet.setAttribute('dir', ar ? 'rtl' : 'ltr');
    root.setAttribute('aria-label', t('share', ar));
    var opener = qs(root, '[data-nilo-share-open]');
    if (opener) opener.setAttribute('aria-label', t('share', ar));
    var lead = opener && qs(opener, '.nilo-share-compact__copy b'); if (lead) lead.textContent = t('share', ar);
    var sub = opener && qs(opener, '.nilo-share-compact__copy small'); if (sub) sub.textContent = t('shareSub', ar);
    var h3 = qs(sheet, '.nilo-share-sheet__head h3'); if (h3) h3.textContent = t('panel', ar);
    var label = qs(sheet, '.nilo-share-sheet__head small'); if (label) label.textContent = t('label', ar);
    var desc = qs(sheet, '.nilo-share-sheet__head p'); if (desc) desc.textContent = t('panelDesc', ar);
    var formats = qs(root, '.nilo-share-formats'); if (formats) formats.setAttribute('aria-label', t('format', ar));
    root.querySelectorAll('[data-nilo-share-format]').forEach(function (el) { el.textContent = t(el.dataset.niloShareFormat === 'square' ? 'square' : 'story', ar); });
    var copy = qs(root, '[data-nilo-share-copy]'); if (copy) copy.textContent = t('copy', ar);
    var product = qs(root, '[data-nilo-share-product-cta]'); if (product) { product.textContent = t('productLink', ar); product.href = productUrl(root); }
    var note = qs(root, '.nilo-share-link-note'); if (note) note.textContent = t('note', ar);
    var preview = qs(root, '[data-nilo-share-preview-image]'); if (preview) preview.alt = t('status', ar);
    root.querySelectorAll('[data-nilo-story-share]').forEach(function (button) {
      button.setAttribute('aria-label', t('platform', ar) + ' · ' + button.dataset.niloStoryShare);
    });
    var platforms = {instagram: ar ? 'شاركي فالستوري أو الريلز' : 'Story · Reel · Publication',
      tiktok: ar ? 'شاركي التصويرة' : 'Publier le visuel Nilo',
      whatsapp: ar ? 'صيفطي الرابط للصحابات' : 'Envoie un lien produit cliquable',
      facebook: ar ? 'ستوري أو منشور' : 'Story · Publication'};
    root.querySelectorAll('[data-nilo-story-share]').forEach(function (button) {
      var small = qs(button, 'small'); if (small) small.textContent = platforms[button.dataset.niloStoryShare] || '';
    });
  }
  function installControls(root) {
    if (root.dataset.niloShareV51361Ready) return;
    root.dataset.niloShareV51361Ready = 'true';
    var sheet = qs(root, '[data-nilo-share-sheet]'), body = qs(root, '.nilo-share-sheet__body'); if (!sheet || !body) return;
    var formats = make('div', 'nilo-share-formats'); formats.setAttribute('role', 'group');
    var story = make('button', 'nilo-share-format is-active', '');
    story.type = 'button'; story.dataset.niloShareFormat = 'story'; story.setAttribute('aria-pressed', 'true');
    var square = make('button', 'nilo-share-format', '');
    square.type = 'button'; square.dataset.niloShareFormat = 'square'; square.setAttribute('aria-pressed', 'false');
    formats.appendChild(story); formats.appendChild(square); body.parentNode.insertBefore(formats, body);
    var toolbar = make('div', 'nilo-share-conversion-actions');
    var download = make('button', 'nilo-share-export', '');
    download.type = 'button'; download.dataset.niloShareDownload = ''; download.disabled = true;
    var copy = make('button', 'nilo-share-copy', '');
    copy.type = 'button'; copy.dataset.niloShareCopy = '';
    toolbar.appendChild(download); toolbar.appendChild(copy);
    body.parentNode.insertBefore(toolbar, body.nextSibling);
    var link = make('a', 'nilo-share-product-link', '');
    link.href = productUrl(root); link.target = '_blank'; link.rel = 'noopener noreferrer'; link.dataset.niloShareProductCta = '';
    toolbar.parentNode.insertBefore(link, toolbar.nextSibling);
    var note = make('p', 'nilo-share-link-note', '');
    link.parentNode.insertBefore(note, link.nextSibling);
    localizePanel(root);
  }
  function openSheet(root) {
    var sheet = qs(root, '[data-nilo-share-sheet]'), opener = qs(root, '[data-nilo-share-open]'); if (!sheet) return;
    sheet.hidden = false; sheet.setAttribute('aria-hidden', 'false'); if (opener) opener.setAttribute('aria-expanded', 'true');
    document.body.classList.add('nilo-share-sheet-open');
    localizePanel(root);
    var state = stateFor(root); state.format = 'story';
    prepare(root);
    setTimeout(function () { var close = qs(sheet, '.nilo-share-sheet__close'); if (close) close.focus({ preventScroll: true }); }, 30);
  }
  function closeSheet(root) {
    var sheet = qs(root, '[data-nilo-share-sheet]'), opener = qs(root, '[data-nilo-share-open]'); if (!sheet) return;
    sheet.hidden = true; sheet.setAttribute('aria-hidden', 'true'); if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
    document.body.classList.remove('nilo-share-sheet-open');
  }
  function fileFromCanvas(root) {
    var state = stateFor(root), canvas = state.canvases[state.format]; if (!canvas) return null;
    try {
      var data = canvas.toDataURL('image/jpeg', .94).split(',')[1], bytes = atob(data), arr = new Uint8Array(bytes.length);
      for (var i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
      var handle = (root.dataset.shareHandle || 'produit').replace(/[^a-z0-9-]+/gi, '-').toLowerCase();
      return new File([arr], 'nilo-' + handle + '-' + state.format + '.jpg', { type: 'image/jpeg' });
    } catch (e) { return null; }
  }
  function downloadImage(root) {
    var file = fileFromCanvas(root);
    if (!file) { setStatus(root, t('loading', isArabic())); return false; }
    var url = URL.createObjectURL(file), anchor = document.createElement('a');
    anchor.href = url; anchor.download = file.name; document.body.appendChild(anchor); anchor.click();
    setTimeout(function () { URL.revokeObjectURL(url); anchor.remove(); }, 3000);
    setStatus(root, t('downloaded', isArabic())); return true;
  }
  function copyLink(root) {
    var value = productUrl(root);
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(value).then(function () { setStatus(root, t('copied', isArabic())); }).catch(function () { legacyCopy(root, value); });
    legacyCopy(root, value); return Promise.resolve();
  }
  function legacyCopy(root, value) {
    var e = make('textarea'); e.value = value; e.readOnly = true; e.style.position = 'fixed'; e.style.opacity = '0';
    document.body.appendChild(e); e.select();
    var ok = false; try { ok = document.execCommand('copy'); } catch (err) {} e.remove();
    setStatus(root, ok ? t('copied', isArabic()) : t('fallback', isArabic()));
  }
  function nativeShare(root) {
    var file = fileFromCanvas(root), info = shareInfo(root);
    if (!file || !navigator.share || (navigator.canShare && !navigator.canShare({ files: [file] }))) return false;
    try {
      navigator.share({ title: info.title, text: info.text, url: info.url, files: [file] }).then(function () {
        setStatus(root, t('sent', isArabic()));
      }).catch(function (err) { if (!err || err.name !== 'AbortError') setStatus(root, t('fallback', isArabic())); });
      return true;
    } catch (e) { return false; }
  }
  function whatsappLink(root) {
    var message = encodeURIComponent(shareInfo(root).text);
    window.open('https://wa.me/?text=' + message, '_blank', 'noopener,noreferrer');
  }
  function sharePlatform(root, platform) {
    if (platform === 'whatsapp') { whatsappLink(root); return; }
    if (nativeShare(root)) return;
    if (downloadImage(root)) {
      copyLink(root); setStatus(root, t('fallback', isArabic()));
    }
  }
  function clickHandler(e) {
    var target = e.target;
    var open = target.closest('[data-nilo-share-open]'); if (open) { var r = open.closest('[data-nilo-share-studio]'); if (r) { e.preventDefault(); openSheet(r); } return; }
    var close = target.closest('[data-nilo-share-close]'); if (close) { var cr = close.closest('[data-nilo-share-studio]'); if (cr) { e.preventDefault(); closeSheet(cr); } return; }
    var format = target.closest('[data-nilo-share-format]');
    if (format) { var fr = format.closest('[data-nilo-share-studio]'); if (fr) { e.preventDefault(); stateFor(fr).format = format.dataset.niloShareFormat; updatePreview(fr); } return; }
    var download = target.closest('[data-nilo-share-download]');
    if (download) { var dr = download.closest('[data-nilo-share-studio]'); if (dr) { e.preventDefault(); downloadImage(dr); } return; }
    var copy = target.closest('[data-nilo-share-copy]');
    if (copy) { var lr = copy.closest('[data-nilo-share-studio]'); if (lr) { e.preventDefault(); copyLink(lr); } return; }
    var social = target.closest('[data-nilo-story-share]');
    if (social) { var sr = social.closest('[data-nilo-share-studio]'); if (sr) { e.preventDefault(); sharePlatform(sr, social.dataset.niloStoryShare); } }
  }
  function changeRefresh(root) {
    var sheet = qs(root, '[data-nilo-share-sheet]');
    if (sheet && !sheet.hidden) prepare(root);
    else { var s = stateFor(root); s.canvases = {}; s.token++; }
  }
  function init() {
    document.querySelectorAll('[data-nilo-share-studio]').forEach(function (root) {
      installControls(root); var page = root.closest('[data-nilo-product-page]'); if (!page) return;
      var timer; function refresh() { clearTimeout(timer); timer = setTimeout(function () { changeRefresh(root); }, 190); }
      page.addEventListener('click', function (e) { if (e.target.closest('[data-nilo-option-value],[data-nilo-thumbnail-index]')) refresh(); });
      var price = qs(page, '[data-nilo-product-price]');
      if (price && window.MutationObserver) new MutationObserver(refresh).observe(price, { subtree: true, childList: true, characterData: true, attributes: true });
      var counter = qs(page, '[data-nilo-gallery-current]');
      if (counter && window.MutationObserver) new MutationObserver(refresh).observe(counter, { subtree: true, childList: true, characterData: true });
    });
  }
  document.addEventListener('click', clickHandler);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var sheet = document.querySelector('[data-nilo-share-sheet]:not([hidden])');
    if (sheet) { var root = sheet.closest('[data-nilo-share-studio]'); if (root) closeSheet(root); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
